<template lang="pug">
div
	v-img.py-8.px-md-12.white--text(src="https://static.wintersport.nl/images/nskiv/longterm.jpg" :aspect-ratio="10" gradient="180deg,rgba(37,63,86, 0.4) 0, rgba(2,11,31,0.4)" height="auto")
		.text-center
			h1.h2.display-3.font-weight-bold Doorlopende reisverzekering
			.h4.title.font-weight-bold {{$t('page.insurance.travel:intro')}}

		.text-center.my-3
			v-btn(depressed color="warning" x-large :to="localePath({name:'verzekering-doorlopend-calculate'})") {{$t('page.insurance.travel:calculate.fee')}}

	insurance-compare-table(type="longterm" :insuranceproviders="insuranceproviders" :insuranceproducts="insuranceproducts" :insuranceratings="insuranceratings")

	insurance-payoff-blocks

	.text-center.mb-6
		v-btn(depressed color="warning" :to="localePath({name:'verzekering-doorlopend-calculate'})") {{$t('page.insurance.travel:calculate.fee')}}

	.ws-content
		.md-generated
			table(style="border:none")
				thead
					tr
						th.pl-0(colspan="3")
							h2 Flexibel mee te verzekeren
						th.text-right.text-no-wrap Gekozen door
				tbody
					tr(v-for="(coverageinfo, index) in coverageinfosLongterm" :key="coverageinfo.id")
						td.pa-0
							v-img(v-if="coverageinfo.photoUrl" :src="`${coverageinfo.photoUrl}?width=640`" min-width="200" :aspect-ratio="16/9")
						td.font-weight-bold.text-no-wrap {{coverageinfo.name}}
						td {{coverageinfo.contentShort}}
						td.text-right {{coverageinfo.percentage}}%

	h2 Échte wintersportdekking
	insurance-info-block

	.text-center.mb-6
		v-btn(depressed color="warning" :to="localePath({name:'verzekering-doorlopend-calculate'})") {{$t('page.insurance.travel:calculate.fee')}}


	insurance-sports-tabs

	.text-center.mb-6
		v-btn(depressed color="warning" :to="localePath({name:'verzekering-doorlopend-calculate'})") {{$t('page.insurance.travel:calculate.fee')}}


	insurance-important-documents

</template>

<script>
import gql from 'graphql-tag';
import insuranceCompareTable from '@/components/insurance-compare-table.vue';
import insurancePayoffBlocks from '@/components/insurance-payoff-blocks.vue';
import insuranceInfoBlock from '@/components/insurance-info-block.vue';
import insuranceSportsTabs from '@/components/insurance-sports-tabs.vue';
import insuranceImportantDocuments from '@/components/insurance-important-documents.vue';

const query = gql`
	query coverageInfos {
		coverageinfos: coverageInfos {
			id
			slug
			name
			contentShort
			percentage
			showInTable
			showInTableShortterm
			photo
			photoUrl
		}
	}
`;

const insuranceProvidersQuery = gql`
	query insuranceProviders {
		insuranceproviders: insuranceProviders {
			id
			sortOrder
			name
			price
			affiliateLink
			type
		}
	}
`;
const insuranceProductsQuery = gql`
	query insuranceProducts {
		insuranceproducts: insuranceProducts {
			id
			sortOrder
			title
			content
			type
		}
	}
`;
const insuranceRatingsQuery = gql`
	query insuranceRatings {
		insuranceratings: insuranceRatings {
			rating
			content
			providerId
			productId
			type
		}
	}
`;

export default {
	nuxtI18n: {
		paths: {
			'nl-NL': '/verzekering/doorlopende-reisverzekering'
		}
	},
	components: {
		insuranceCompareTable,
		insurancePayoffBlocks,
		insuranceInfoBlock,
		insuranceSportsTabs,
		insuranceImportantDocuments
	},
	layout: 'default',
	async asyncData({ app }) {
		const client = app.$graphClient;

		const { coverageinfos } = await client
			.query({
				query,
				variables: {}
			})
			.then(({ data }) => {
				return data;
			});

		const { insuranceproviders } = await client
			.query({
				query: insuranceProvidersQuery,
				variables: {}
			})
			.then(({ data }) => {
				return data;
			});
		const { insuranceproducts } = await client
			.query({
				query: insuranceProductsQuery,
				variables: {}
			})
			.then(({ data }) => {
				return data;
			});
		const { insuranceratings } = await client
			.query({
				query: insuranceRatingsQuery,
				variables: {}
			})
			.then(({ data }) => {
				return data;
			});

		app.ads({});
		app.meta({
			title:
				'Dé reisverzekering voor wintersporters - Nederlandse Ski Vereniging',
			description:
				'We weten ook dat het aanvinken van het hokje ‘wintersportdekking’ bij een reisverzekering lang niet altijd genoeg is om deze risico’s af te dekken.',
			hasFollow: true,
			hasIndex: true
		});
		app.breadcrumbs({
			[app.i18n.t('page.insurance:breadcrumb')]: { name: 'verzekering' },
			[app.i18n.t('page.insurance.travel:breadcrumb')]: {
				name: 'verzekering-doorlopend'
			}
		});

		return {
			coverageinfos,
			insuranceproviders,
			insuranceproducts,
			insuranceratings
		};
	},
	head() {
		return {
			...this.$structuredData()
		};
	},
	computed: {
		coverageinfosLongterm() {
			return this.coverageinfos.filter(c => {
				return c.showInTable;
			});
		}
	}
};
</script>
